/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import getImageRenditions from '../../utils/getImageRenditions'
import { DEFAULT_GROUPTOKEN, POSTER_RENDITIONS } from '../../constants'
import styles from './styles'
import PlayerApi from '../../utils/playerApi'
import {
  getTabs,
} from '../SummaryPage/summaryData'
import {
  Scroller,
  Tabs,
  Tab,
  Group,
  PlayerApiFetch,
  Spinner,
} from '..'
import { remapCardContent } from '../SummaryPage/summaryData/getTabs'

const LiveTabs = ({
  cacheResults,
  groupToken,
  promoted,
}) => {
  const programmeGuid = cacheResults?.now?.programme?.guid
  const [recommended, setRecommended] = useState(null)
  const [mainTab, setMainTab] = useState([])
  const [episodes, setEpisodes] = useState([])
  const [meta, setMeta] = useState(null)
  const playerApi = PlayerApi()

  useEffect(() => {
    const getTabData = async () => {
      try {
        if (cacheResults && cacheResults?.now?.programme) {
          const [
            { results: progData },
            { data: recommendedData, metaData },
          ] = await Promise.all([
            playerApi({
              path: `/programmes/${programmeGuid}`,
              query: { groupToken: DEFAULT_GROUPTOKEN },
            }),
            playerApi({
              path: `/recommended/content/${programmeGuid}`,
              query: { programmeGuid, groupToken, limit: 5 },
            }),
          ])
          if (recommendedData) {
            const recommendedCards = recommendedData.map(extractRecommendedData)
            const shuffledRecommended = recommendedCards.sort(() => Math.random() - 0.5).slice(0, 5)
            setRecommended(shuffledRecommended)
            setMeta(metaData)
          }

          const tabData = await getTabs({
            programmeData: progData,
            programmeGuid,
            playerApi,
          })

          let newMainTab = [{ id: 'episode', title: 'Episodes' }, { id: 'more', title: 'More like this' }]
          const episode = tabData?.filter(tab => tab?.type !== 'video')
          setEpisodes(episode)

          if (!progData || progData?.searchCategories.includes('Movies') || progData?.availableEpisodes === 1) {
            newMainTab = newMainTab.filter(obj => obj.id !== 'episode')
          }
          if (!recommendedData || recommendedData?.length < 1) {
            newMainTab = newMainTab.filter(obj => obj.id !== 'more')
          }
          setMainTab(newMainTab)
        }
      } catch (error) {
        setEpisodes([])
      }
    }
    if (programmeGuid) getTabData()
  }, [programmeGuid])

  const extractRecommendedData = r => ({
    programmeName: r?.name,
    numEpisodes: parseInt(r?.availableEpisodes, 10),
    link: `/summary/${r.id}`,
    image: getImageRenditions(
      r?.images?.find(poster => poster.imageType === 'PPMB')?._filepath,
      POSTER_RENDITIONS
    ),
    id: r.id,
    genre: r.genre,
  })

  return (
    <div>
      {mainTab?.length > 0 ? (
        <section className="featureTab-Wrapper">
          <Tabs tabs={mainTab} liveTab programmeGuid={programmeGuid} isLive>
            { mainTab.map((tab, i) => (
              <Tab
                key={tab.id}
                id={tab.id}
              >
                <ul>
                  {tab.id === 'episode' && episodes !== null && (
                    <li className="featured-tab-item" key={tab.id}>
                      { episodes[0]?.title !== 'Episodes' ? (
                        <section className="featured-tabs">
                          <Tabs tabs={episodes} subTab programmeGuid={programmeGuid} isLive>
                            { episodes.map((subtab, id) => (
                              <Tab
                                key={subtab.id}
                                id={subtab.id}
                              >
                                <div className="subtabclass">
                                  {subtab?.data && (
                                    <Scroller
                                      assets={subtab?.data}
                                      recoID={null}
                                      liveTab
                                      playIcon
                                      isLive
                                    />
                                  )}

                                  {/* otherwise, prepare for lazy loading content when activated */}
                                  { !subtab?.data && subtab?.params && (
                                    <PlayerApiFetch
                                      params={subtab?.params}
                                      success={(results) => {
                                        if (!results) return null
                                        const resultData = results.map(item => remapCardContent({ item, type: subtab.type }))
                                        return (
                                          <Scroller
                                            assets={resultData}
                                            recoID={null}
                                            liveTab
                                            isLive
                                          />
                                        )
                                      }}
                                      fetching={() => <div className="tab-loader"><Spinner /></div>}
                                      fail={() => (
                                        <p>Sorry, we couldn't load that content. Try refreshing this page.</p>
                                      )}
                                    />
                                  )}
                                </div>
                              </Tab>
                            ))}
                          </Tabs>

                        </section>
                      )
                        : (episodes !== null
                              && (
                                <section className="featured-tabs">
                                  <Scroller
                                    assets={episodes[0]?.data}
                                    recoID={null}
                                    liveTab
                                    isLive
                                  />
                                </section>
                              )

                        )}
                    </li>
                  )}

                  {tab.id === 'more' && recommended && (
                    <section className="recommended" data-swiftype-index="false">
                      <Scroller
                        assets={recommended}
                        recoID={meta?.analytics?.personalisationRequestID || meta?.analytics?.recommendationRequestId}
                        recommendedTab
                        liveTab={false}
                        isLive
                      />
                    </section>
                  )}
                </ul>
              </Tab>
            ))}
          </Tabs>
        </section>
      ) : (
        <Group
          key={promoted.id}
          {...promoted}
          showTitle
          specialEvent={false}
          showCardTitle
          rowTitle={`${promoted.name} - Live`}
          isLive
        />
      )}
      <style jsx>{styles}</style>
    </div>
  )
}

const mapStateToProps = ({ playerApiCache }, { channel }) => ({
  cacheResults: playerApiCache[`/streams/${channel}`]?.results,
})

LiveTabs.propTypes = {
  channel: PropTypes.string.isRequired,
  groupToken: PropTypes.string,
  promoted: PropTypes.object,
  cacheResults: PropTypes.object,
}

LiveTabs.defaultProps = {
  promoted: {},
  groupToken: null,
  cacheResults: null,
}

export default connect(mapStateToProps)(LiveTabs)
